export default __webpack_public_path__ + "static/media/dqIcon.9181d014.png";